import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import {
  getGeneralPensionPercent,
  getGeneralPensionCutOffValue,
} from "../../Redux/Actions/salarycalculation";
import { getErrorMessage } from "../../Redux/Actions/errorMessage";
import { initialState } from "../../Redux/Reducers/salaryCalculationTaxFigures";
//windowsize
import useWindowSize from "../../Component/use-window-size";

const GeneralPension = ({ setHeadingFocused }) => {
  //get current windowsize
  const size = useWindowSize();
  const [cardFocused, setCardFocused] = useState(false);
  const [inputCutOffValue, setCutOfValue] = useState(
    initialState.generalPensionCutOffValue
  );
  const [inputPercent, setInputPercent] = useState(
    initialState.generalPensionPercent
  );

  const generalPension = useSelector(
    (state) => state.salaryCalculation.generalPension
  );
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);
  const dispatch = useDispatch();

  function handleChange(e, input) {
    const regex = /^(\d+(\.\d{0,5})?|\.?\d{1,2})$/;
    e.preventDefault();
    if (e.target.value.match(regex)) {
      if (input === "cutOffValue") {
        setCutOfValue(parseInt(e.target.value) || "");
      }
      if (input === "percent") {
        setInputPercent(parseFloat(e.target.value) || "");
      }
    } else {
      e.target.value = e.target.value.replace(/[^/\d\d{1,2}]/g, "");
      dispatch(
        getErrorMessage(`Felaktig inmatning, var god skriv in siffror!`)
      );
      const delayEditData = setTimeout(() => {
        dispatch(getErrorMessage(""));
      }, 5000);
      return () => clearTimeout(delayEditData);
    }
  }

  useEffect(() => {
    dispatch(getGeneralPensionCutOffValue(inputCutOffValue));
    dispatch(getGeneralPensionPercent(inputPercent));
  }, [dispatch, inputCutOffValue, inputPercent]);

  const card = {
    backgroundColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    transition: "0.5s",
    width: "100%",
  };
  const heading = {
    color: cardFocused ? "#000000" : "#777",
    overflow: "hidden",
    whiteSpace: "nowrap",
    cursor: "default",
  };
  const inputElement = {
    color: cardFocused ? "#000000" : "#777",
  };
  const outputElement = {
    backgroundColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    borderColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    transition: "0.5s",
    color: cardFocused ? "#000000" : "#777",
    cursor: "default",
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  return (
    <>
      {size.width < sizeForMobile ? (
        <Row
          className="g-0 mt-2 m-auto rounded-3"
          style={card}
          onFocus={() => setCardFocused(true)}
          onBlur={() => setCardFocused(false)}
        >
          <Col
            xs={40}
            className="p-1 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={heading}
          >
            Allmän Pension
          </Col>

          <Col xs={17} className="offset-2 p-0" style={{ padding: "0px" }}>
            <input
              type="text"
              className="form-control text-center"
              name="cutOffValue"
              style={inputElement}
              defaultValue={inputCutOffValue}
              autoComplete="off"
              maxLength="7"
              onChange={(e) => handleChange(e, "cutOffValue")}
              onFocus={(e) => setHeadingFocused(e.target.name)}
              onBlur={() => setHeadingFocused("")}
            />
          </Col>

          <Col xs={17} className="offset-2 p-0" style={{ padding: "0px" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <label className="label-mobile-percent">%</label>
              <input
                type="text"
                className="form-control text-center"
                name="percent"
                style={inputElement}
                defaultValue={inputPercent}
                autoComplete="off"
                maxLength="5"
                onChange={(e) => handleChange(e, "percent")}
                onFocus={(e) => setHeadingFocused(e.target.name)}
                onBlur={() => setHeadingFocused("")}
              />
            </div>
          </Col>

          <Col xs={20} className="p-0 offset-10" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              -{" "}
              {generalPension > 0 || generalPension < 0
                ? Math.round(generalPension)
                : 0}
            </output>
          </Col>
        </Row>
      ) : (
        <Row
          className="g-0 mt-2 m-auto rounded-3"
          style={card}
          onFocus={() => setCardFocused(true)}
          onBlur={() => setCardFocused(false)}
        >
          <Col
            xs={17}
            className="p-2 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={heading}
          >
            Allmän Pension
          </Col>

          <Col xs={6} className="offset-4 p-2" style={{ padding: "0px" }}>
            <input
              type="text"
              className="form-control text-center"
              name="cutOffValue"
              style={inputElement}
              defaultValue={inputCutOffValue}
              autoComplete="off"
              maxLength="7"
              onChange={(e) => handleChange(e, "cutOffValue")}
              onFocus={(e) => setHeadingFocused(e.target.name)}
              onBlur={() => setHeadingFocused("")}
            />
          </Col>

          <Col xs={5} className="offset-1 p-2" style={{ padding: "0px" }}>
            <input
              type="text"
              className="form-control text-center"
              name="percent"
              style={inputElement}
              defaultValue={inputPercent}
              autoComplete="off"
              maxLength="5"
              onChange={(e) => handleChange(e, "percent")}
              onFocus={(e) => setHeadingFocused(e.target.name)}
              onBlur={() => setHeadingFocused("")}
            />
          </Col>

          <Col xs={7} className="p-2" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              -{" "}
              {generalPension > 0 || generalPension < 0
                ? Math.round(generalPension)
                : 0}
            </output>
          </Col>
        </Row>
      )}
    </>
  );
};
export default GeneralPension;
